import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import { Button } from 'tea-component';

import type { IBaseProps } from '@intelligence/types/common';

import './index.scss';

type ISwiperType = 'prev' | 'next';

interface ISwiperBtnProps extends IBaseProps {
  type: ISwiperType;
  disabled: boolean;
  // 是否开启边缘渐变效果（滑动体边缘被遮挡部分，有个透明渐变效果，让用户更容易发现 有内容被遮挡，可以点击滑动按钮滑动 查看 遮挡的内容），默认关闭
  gradient?: boolean;
  onClick: (payload: ISwiperType) => void;
}

const SwiperBtn: React.FC<ISwiperBtnProps> = (props) => {
  const { type = 'next', disabled = false, gradient = false, onClick, className, style } = props;

  const iconType = type === 'next' ? 'point-right' : 'point-left';

  return (
    <Button
      style={style}
      className={classnames('dbi-swiper-icon-wrap', className, {
        'dbi-swiper-icon-wrap--left': type === 'prev',
        'dbi-swiper-icon-wrap--right': type === 'next',
        'dbi-swiper-icon-wrap--gradient': gradient,
        'dbi-swiper-icon-wrap--disabled': disabled,
      })}
      type="link"
      disabled={disabled}
    >
      <div className={classnames('dbi-swiper-icon', { disabled })} onClick={() => onClick(type)}>
        <SvgIcon className="dbi-swiper-arrow" type={iconType} />
      </div>
    </Button>
  );
};

export default SwiperBtn;
